import EcoSpace from 'eco-design/base/eco-space';
import Video from '@/components/XPower/elements/Video';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import { useEffect, useState } from 'react';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.SectionE');
    const { locale = 'us' } = useRouter();
    const [enter, setEnter] = useState<boolean>(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer.create({
                triggerElement: '#SectionE .process-lists-list-left-bar.bar2',
                triggerHook: 1,
                offset: 0,
                duration: '100%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });
            return () => scene.destroy();
        }
    }, []);

    return (
        <div className={styles.comp} id="SectionE">
            <EcoSpace />
            <div className="section-container">
                <div className="content-wrapper">
                    <div className="title-area">
                        <EFXStream className="logo" color="#000" />
                    </div>
                    <div className="desc-area">
                        <p className="desc-text">{t('desc')}</p>
                        <p className="desc-tip">{t('tip')}</p>
                        <div className="link-flex-container">
                            <a href={`/${locale}/x-core-3`} className="learn-more">
                                {t('learnMore')} {`${locale}`.toUpperCase()}
                            </a>
                            <span className="learn-more-arrow"></span>
                        </div>
                    </div>
                </div>
                <EcoSpaceSmall />
                <div className="video-wrapper">
                    <Video src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718700578464/X-stream.mp4" />
                </div>
                <div className={`process${enter ? ' enter' : ''}`}>
                    <p className="process-title">{t('progress.progress_title')}</p>
                    <ul className="process-lists">
                        <li className="process-lists-list">
                            <div className="process-lists-list-left">
                                <p className="process-lists-list-left-bar bar1"></p>
                                <span className="process-lists-list-left-text">{t('progress.progress_text1')}</span>
                            </div>
                            <span className="process-lists-list-right">90{t('progress.progress_unit')}</span>
                        </li>
                        <li className="process-lists-list">
                            <div className="process-lists-list-left">
                                <p className="process-lists-list-left-bar bar2"></p>
                                <span className="process-lists-list-left-text">{t('progress.progress_text2')}</span>
                            </div>
                            <span className="process-lists-list-right r2">50{t('progress.progress_unit')}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
